module.exports = "https://coursera_assets.s3.amazonaws.com/images/0f8d6ea3d3b5093c238c2e7c2a59252d.png";